import * as Actions from '../Actions/EmpresaFormaPagamentoActions';
// import _ from '@lodash';

const initialState = {
    data: null,
    pagina: 1,
    template: null,
    formDialog: {
        type: 'new',
        props: {
            open: false,
            xappRouteParams: '',
            error: null,
            warning: null,
            info: null
        },
        data: null
    },
    error: null

};

const EmpresaFormaPagamentoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESAFORMAPAGAMENTOS:
            {
                return {
                    ...state,
                    data: action.pagina === 1 ? action.payload : state.data.concat(action.payload),
                    pagina: action.pagina,
                };
            }
        case Actions.GET_EMPRESAFORMAPAGAMENTO:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'edit',
                        props: {
                            open: true

                        },
                        data: action.payload
                    }
                };
            }
        case Actions.OPEN_NEW_EMPRESAFORMAPAGAMENTO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'new',
                        props: {
                            open: true,
                            xappRouteParams: action.xappRouteParams
                        },
                        data: null
                    }
                };
            }
        case Actions.CLOSE_NEW_EMPRESAFORMAPAGAMENTO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'new',
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.OPEN_EDIT_EMPRESAFORMAPAGAMENTO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'edit',
                        props: {
                            open: true,
                            xappRouteParams: action.xappRouteParams

                        },
                        data: action.data
                    }
                };
            }
        case Actions.CLOSE_EDIT_EMPRESAFORMAPAGAMENTO_DIALOG:
            {
                return {
                    ...state,
                    formDialog: {
                        type: 'edit',
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.EMPRESAFORMAPAGAMENTO_ERROR:
            {
                return {
                    ...state,
                    formDialog: {
                        ...state.formDialog,
                        props: {
                            ...state.formDialog.props,
                            error: action.payload
                        }
                    }
                };
            }
        case Actions.EMPRESAFORMAPAGAMENTO_INFO:
            {
                return {
                    ...state,
                    formDialog: {
                        ...state.formDialog,
                        props: {
                            ...state.formDialog.props,
                            info: action.payload,
                            id: action.id,
                            open: false,
                        }
                    }
                };
            }
        case Actions.EMPRESAFORMAPAGAMENTO_WARNING:
            {
                return {
                    ...state,
                    formDialog: {
                        ...state.formDialog,
                        props: {
                            ...state.formDialog.props,
                            warning: action.payload
                        }
                    }
                };
            }
        case Actions.GET_TEMPLATE:
            {
                return {
                    ...state,
                    template: action.payload
                };
            }
        default:
            {
                return state;
            }
    }
};

const reducer = EmpresaFormaPagamentoReducer;
export default reducer;
